import formatToTimeZone from '@dubbletrack/time/utils/format-to-time-zone';

// What the OS media controls (lock screen, notification, car display) show.
//
// Every field is derived from scratch on each call and the shape is always
// complete: a field with nothing behind it is explicitly undefined. That's
// deliberate: these get spread over the existing metadata, so a key we left out
// would keep the *previous* item's value and strand, say, a finished song's
// artist beside the next show's title.
//
// The flip side is that coming up empty blanks the card mid-playback, so the
// title falls back through everything we know rather than dead-ending on the
// item type alone: song, then show, then the station's call sign for an
// unscheduled block. A station we're playing always has a call sign, so the card
// is never nameless.
export default function nowPlayingMetadata(metadata, options = {}) {
  let track = metadata.itemType === 'track' ? metadata.track : undefined;
  let stationName = metadata.station?.callSign;
  let showName =
    metadata.airing?.showTitle || metadata.show?.title || metadata.airing?.title;

  let title = track?.title || showName || stationName;

  // The track's artist, or the day an archive aired. Live needs no saying.
  let artist = track?.artistName || broadcastDate(metadata, options.timeZone);

  return {
    title,
    artist,
    album: track?.releaseName,
    artwork: artworkFor(metadata.imageSource),
  };
}

// The day this aired, in the listener's zone. Nothing for live.
function broadcastDate(metadata, timeZone) {
  let startsAt = metadata.airing?.startsAt;

  if (metadata.isLive || !startsAt) {
    return undefined;
  }

  return formatToTimeZone(
    startsAt,
    { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' },
    { timeZone }
  );
}

function artworkFor(imageSource) {
  if (!imageSource) {
    return undefined;
  }

  let artwork = [
    imageSource.small_square?.url && {
      src: imageSource.small_square.url,
      sizes: '250x250',
    },
    imageSource.medium_square?.url && {
      src: imageSource.medium_square.url,
      sizes: '500x500',
    },
    imageSource.large_square?.url && {
      src: imageSource.large_square.url,
      sizes: '1500x1500',
    },
  ].filter(Boolean);

  return artwork.length > 0 ? artwork : undefined;
}
